import { useMemo } from 'react';
import { generateHTML } from '@tiptap/html';
import StarterKit from '@tiptap/starter-kit';

// StarterKit v3 bundles Link; configure it here to avoid the duplicate-name warning.
const extensions = [StarterKit.configure({ link: { openOnClick: true, autolink: true } })];

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TipTap JSON is untyped
  content: Record<string, any>;
}

export function ReaderCanvas({ content }: Props) {
  const html = useMemo(() => generateHTML(content, extensions), [content]);

  return (
    <div
      className="prose prose-lg max-w-none"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
